import { defineMessages } from 'react-intl';

export const scope = 'app.components.RsvpIdentityBanner';

// Copy naming who an RSVP link belongs to, plus the wrong-account warning.
export const messages = defineMessages({
  respondingAs: {
    id: `${scope}.respondingAs`,
    defaultMessage: 'Responding as {identity}'
  },
  mismatchWarning: {
    id: `${scope}.mismatchWarning`,
    defaultMessage: 'You are signed in as a different contact — anything you respond to here is recorded as the contact this link was sent to.'
  },
  signedInAs: {
    id: `${scope}.signedInAs`,
    defaultMessage: 'Signed in as {identity}'
  },
  linkSentTo: {
    id: `${scope}.linkSentTo`,
    defaultMessage: 'This link was sent to {identity}'
  },
  addToAccount: {
    id: `${scope}.addToAccount`,
    defaultMessage: 'Add {credential} to my account'
  },
  switchAccount: {
    id: `${scope}.switchAccount`,
    defaultMessage: 'Sign out & sign in as {contact}'
  },
  cancel: {
    id: `${scope}.cancel`,
    defaultMessage: 'Cancel'
  }
});
